
export default {
    load(path){
        let style = document.createElement('link');
        style.type = "text/css";
        style.rel = "stylesheet";
        style.href = process.env.VUE_APP_BASE_URL + path;
        document.head.appendChild(style);
    }
}